import { USER_ORDER_STATUS } from "@/constants/status.constant";
import { OrderSubGraphType } from "@/types/orders";
import { formatAmount } from "./amount";

export const getVolume = (orders: OrderSubGraphType[]) => {
  let amt = 0;
  orders?.map((item) => {
    if (item.status == USER_ORDER_STATUS.COMPLETED) {
      amt += parseInt(item.amount);
    }
  });
  return formatAmount(amt);
};
